


























































































import { Vue, Component } from 'vue-property-decorator'
import { DcxImage, EnhancedPost, Block } from '../../common/types'
import { enhance } from '../../plugins/utils'
import Article from '~components/content/detail-view/Article.vue'
import Page from '~components/content/pages/Page.vue'

@Component({
  layout: 'empty',
  components: {
    Article,
    Page,
  },
})
export default class Preview extends Vue {
  private post: EnhancedPost | null = null
  private loading = false

  async mounted() {
    this.loading = true
    this.$store.dispatch('news/setInPreviewContext')
    let query = `p=${this.$route.query.id}`
    if (this.$route.query.page_id) {
      query = `page_id=${this.$route.query.page_id}`
    }
    const previewUrl = `${this.$config.backend}/?${query}&preview=true&json=true`
    const response = await fetch(previewUrl, {
      credentials: 'include',
    })
    const contentAsJson = await response.json()
    this.post = enhance(contentAsJson, this.$config) as EnhancedPost
    this.loading = false
  }

  get coreImages(): (Block & { dcxId: string })[] | undefined {
    const imageBlocks = this.post?.blocks.filter(
      (block) => block.ot === 'core/image'
    )

    this.post?.blocks
      .filter((block) => block.ot === 'core/gallery')
      .reduce((acc, gallery) => {
        const innerImages = gallery.innerBlocks?.filter(
          (block) => block.ot === 'core/image'
        )
        if (innerImages && innerImages.length > 0) {
          acc.push(...innerImages)
        }
        return acc
      }, imageBlocks || [])

    return (
      imageBlocks?.reduce((acc, block) => {
        const dcxId = block.a!.find((a) => a.key === 'dcx_id')
        if (dcxId?.value) {
          acc.push({
            ...block,
            dcxId: dcxId.value,
          })
        }
        return acc
      }, [] as (Block & { dcxId: string })[]) || []
    )
  }

  get dcxImages(): DcxImage[] | undefined {
    return this.post?.blocks
      .filter((block) => block.ot === 'russmedia/dcx-image')
      .reduce((acc, block) => {
        // acc.push(block.data.image.url)
        const imagesJson = block.a!.find((a) => a.key === 'images')
        if (imagesJson?.value) {
          const images = JSON.parse(imagesJson.value)
          images.forEach((image: DcxImage) => acc.push(image))
        }
        return acc
      }, [] as DcxImage[])
  }

  get isPage() {
    return this.$route.query.page_id
  }

  get settings() {
    return this.$config.backend
  }
}
